import React, {useState, useEffect, forwardRef} from 'react';

import {useSessionStore} from '../../hooks/useSessionStore';
import {UsuarioContext} from '../../contexts/UsuarioContext';

import {useNavigate} from 'react-router-dom';

import {Modal as M} from 'react-bootstrap';
import 'react-modern-calendar-datepicker/lib/DatePicker.css';

import {registerLocale, setDefaultLocale} from 'react-datepicker';

import es from 'date-fns/locale/es';

import 'moment/locale/it.js';
import 'moment/locale/es.js';
import moment from 'moment';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';

import { HoraSeleccionar } from './HoraSeleccionar';
import { ModalAnadirServicioNormal } from './ModalAnadirServicioNormal';
import { ModalAnadirServicioSC } from './ModalAnadirServicioSC';
import { ModalAnadirPaqueteServicioSC } from './ModalAnadirPaqueteServicioSC';

export const ModalesPerfilAgencia = (props) => {
    const { ModalAnadirServicio, setModalAnadirServicio, ModalAnadirServicioShareCare, setModalAnadirServicioShareCare, ServicioId, MyDate, setMyDate, ServiciosContratados, setServiciosContratados, Servicio, idPrestador, DiasNoCompletos, DiasLibres, Periodos, Periodo, getHoras, ListaHoras, setListaHoras, generarHorasDisponibles, ModalUsuarioNoRegistrado, setModalUsuarioNoRegistrado, ModalPacientes, setModalPacientes, ListaPacientes, Paciente, seleccionarPaciente, enviarServicio, getHorasShareCare, empresa, createPayment, stripeMessage, get_clientSecret, clientSecret, factura, Paquete, ModalAnadirPaqueteServicioShareCare, setModalAnadirPaqueteServicioShareCare, metodoPago, setMetodoPago, saldo, paymentIntent } = props;

	/* A hook that is used to store the user's data in the session. */
	const [Usuario, setUsuario] = useSessionStore(UsuarioContext);

	registerLocale('es', es);
	const stepsCuidatia = ['Resumen', 'Pago', 'Aceptar', 'Estado']; 
	const stepsNormal = ['Fecha', 'Hora', 'Resumen', 'Pago', 'Aceptar', 'Estado'];

	const steps = empresa?.datos?.nombreEmpresa === "Cuidatia" ? stepsCuidatia : stepsNormal;

	const [activeStep, setActiveStep] = React.useState(0);
	const [skipped, setSkipped] = React.useState(new Set());

	const [EstadoConsulta, setEstadoConsulta] = useState(undefined);

	const [ModalSeleccionHora, setModalSeleccionHora] = useState(false);
	const [ModalSeleccionPaciente, setModalSeleccionPaciente] = useState(false);
	/* A hook that is used to navigate between pages. */
	const navigate = useNavigate();

	const generarListaDias = () => {
		let listaDias = [];
		if (DiasNoCompletos !== undefined) {
			DiasNoCompletos.map((dia) => {
				// hay que comprobar que no hay horas libres
				if (dia.horarios.length == 0) {
					listaDias.push(new Date(dia.fecha));
				}
			});
		}
		let diasFiltrados = [];
		Periodos.forEach((element) => {
			if (!diasFiltrados.includes(element.nombre)) {
				diasFiltrados.push(element.nombre);
			}
		});
		const fechaActual = new Date();
		const fechaInicio = new Date(
			fechaActual.getFullYear(),
			fechaActual.getMonth(),
			fechaActual.getDate()
		); // fecha actual
		const fechaFin = new Date(
			fechaActual.getFullYear() + 1,
			fechaActual.getMonth(),
			fechaActual.getDate() - 1
		); // un año después de la fecha actual
		const fechas = [];
		for (let fecha = fechaInicio; fecha <= fechaFin; fecha.setDate(fecha.getDate() + 1)) {
			let diaSemana = fecha.toLocaleString('es-ES', {weekday: 'long'}).toLowerCase(); // obtener el día de la semana en minúsculas
			diaSemana = diaSemana.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
			if (!diasFiltrados.includes(diaSemana)) {
				const fechaString = fecha.toLocaleDateString('es-ES', {
					year: 'numeric',
					month: '2-digit',
					day: '2-digit',
				});
				const fechaISO = moment(fechaString, 'DD/MM/YYYY').format('YYYY-MM-DD');
				const fechaDos = new Date(fechaISO);
				listaDias.push(new Date(fechaDos));
			}
		}
		return listaDias;
	};

	// Función para agregar meses a una fecha
	const addMonths = (date, months) => {
		const newDate = new Date(date.getTime());
		const currMonth = newDate.getMonth();
		newDate.setMonth(currMonth + months);
		if (newDate.getMonth() !== (currMonth + months) % 12) {
			newDate.setDate(0);
		}
		return newDate;
	};

	// Función para restar meses a una fecha
	const subMonths = (date, months) => addMonths(date, -months);

	// Función para agregar días a una fecha
	const addDays = (date, days) => {
		const newDate = new Date(date.getTime() + days * 24 * 60 * 60 * 1000);
		return newDate;
	};

	// Función para restar días a una fecha
	const subDays = (date, days) => addDays(date, -days);

	const ExampleCustomInput = forwardRef(({value, onClick}, ref) => (
		<div
			className='button-fecha-perfil-agencia'
			onClick={onClick}
			ref={ref}
		>
			<div className='centrador'>
				<svg
					xmlns='http://www.w3.org/2000/svg'
					width='16'
					height='16'
					fill='currentColor'
					class='bi bi-calendar-fill'
					viewBox='0 0 16 16'
				>
					<path d='M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5h16V4H0V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5z' />
				</svg>
			</div>
			<div className='centrador'>
				<b>{value}</b>
			</div>
		</div>
	));

	const anadiServicioLista = () => {};

	useEffect(() => {}, []);

	const changeHora = (hora) => {
		let lista = ListaHoras;
		lista.map((horaInd) => {
			if (horaInd.hora === hora.hora) {
				horaInd.estado = !horaInd.estado;
			} else {
				horaInd.estado = false;
			}
		});
		setListaHoras([...lista]);
	};

	const modHoraModal = () => {
		const diasSemana = [
			'Domingo',
			'Lunes',
			'Martes',
			'Miércoles',
			'Jueves',
			'Viernes',
			'Sábado',
		];
		const meses = [
			'Enero',
			'Febrero',
			'Marzo',
			'Abril',
			'Mayo',
			'Junio',
			'Julio',
			'Agosto',
			'Septiembre',
			'Octubre',
			'Noviembre',
			'Diciembre',
		];

		const diaSemana = diasSemana[MyDate.getDay()];
		const dia = MyDate.getDate();
		const mes = meses[MyDate.getMonth()];
		const anio = MyDate.getFullYear();

		const fechaFormateada = `${diaSemana} ${dia} de ${mes} de ${anio}`;
		return fechaFormateada;
	};
	const isStepSkipped = (step) => {
		return skipped.has(step);
	};

	const hayHora = () => ListaHoras.some((hora) => hora.estado === true);

	const enviarYMostrarResultado = async () => {
		const resultado = await enviarServicio();
		setEstadoConsulta(resultado);
	};

	return (
		<>
			<ModalAnadirServicioNormal
				ModalAnadirServicio={ModalAnadirServicio}
				setModalAnadirServicio={setModalAnadirServicio}
				Servicio={Servicio}
				activeStep={activeStep}
				setActiveStep={setActiveStep}
				MyDate={MyDate}
				setMyDate={setMyDate}
				addMonths={addMonths}
				generarListaDias={generarListaDias}
				ListaHoras={ListaHoras}
				EstadoConsulta={EstadoConsulta}
				ModalSeleccionHora={ModalSeleccionHora}
				setModalSeleccionHora={setModalSeleccionHora}
				ModalSeleccionPaciente={ModalSeleccionPaciente}
				setModalSeleccionPaciente={setModalSeleccionPaciente}
				ExampleCustomInput={ExampleCustomInput}
				changeHora={changeHora}
				ListaPacientes={ListaPacientes}
				Paciente={Paciente}
				seleccionarPaciente={seleccionarPaciente}
				modHoraModal={modHoraModal}
				steps={steps}
				isStepSkipped={isStepSkipped}
				anadiServicioLista={anadiServicioLista}
				getHoras={getHoras}
				hayHora={hayHora}
				enviarYMostrarResultado={enviarYMostrarResultado}
				empresa={empresa}
				createPayment={createPayment}
				get_clientSecret={get_clientSecret}
				clientSecret={clientSecret}
				stripeMessage={stripeMessage}
				factura={factura}
			/>

			<ModalAnadirServicioSC
				ModalAnadirServicioShareCare={ModalAnadirServicioShareCare}
				setModalAnadirServicioShareCare={setModalAnadirServicioShareCare}
				Servicio={Servicio}
				activeStep={activeStep}
				setActiveStep={setActiveStep}
				MyDate={MyDate}
				setMyDate={setMyDate}
				addMonths={addMonths}
				generarListaDias={generarListaDias}
				ListaHoras={ListaHoras}
				EstadoConsulta={EstadoConsulta}
				ModalSeleccionHora={ModalSeleccionHora}
				setModalSeleccionHora={setModalSeleccionHora}
				ModalSeleccionPaciente={ModalSeleccionPaciente}
				setModalSeleccionPaciente={setModalSeleccionPaciente}
				ExampleCustomInput={ExampleCustomInput}
				changeHora={changeHora}
				ListaPacientes={ListaPacientes}
				Paciente={Paciente}
				seleccionarPaciente={seleccionarPaciente}
				modHoraModal={modHoraModal}
				steps={steps}
				isStepSkipped={isStepSkipped}
				anadiServicioLista={anadiServicioLista}
				getHoras={getHoras}
				hayHora={hayHora}
				enviarYMostrarResultado={enviarYMostrarResultado}
				getHorasShareCare={getHorasShareCare}
				empresa={empresa}
				createPayment={createPayment}
				get_clientSecret={get_clientSecret}
				clientSecret={clientSecret}
				stripeMessage={stripeMessage}
				factura={factura}
				metodoPago={metodoPago}
				setMetodoPago={setMetodoPago}
				saldo={saldo}
				paymentIntent={paymentIntent}
			/>
        <ModalAnadirPaqueteServicioSC
            ModalAnadirPaqueteServicioShareCare={ModalAnadirPaqueteServicioShareCare}
            setModalAnadirPaqueteServicioShareCare={setModalAnadirPaqueteServicioShareCare}
            Paquete={Paquete}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            MyDate={MyDate}
            setMyDate={setMyDate}
            addMonths={addMonths}
            generarListaDias={generarListaDias}
            ListaHoras={ListaHoras}
            EstadoConsulta={EstadoConsulta}
            ModalSeleccionHora={ModalSeleccionHora}
            setModalSeleccionHora={setModalSeleccionHora}
            ModalSeleccionPaciente={ModalSeleccionPaciente}
            setModalSeleccionPaciente={setModalSeleccionPaciente}

            ExampleCustomInput={ExampleCustomInput}
            changeHora={changeHora}
            ListaPacientes={ListaPacientes}
            Paciente={Paciente}
            seleccionarPaciente={seleccionarPaciente}
            modHoraModal={modHoraModal}
            isStepSkipped={isStepSkipped}
            anadiServicioLista={anadiServicioLista}
            getHoras={getHoras}
            hayHora={hayHora}
            enviarYMostrarResultado={enviarYMostrarResultado}
            getHorasShareCare={getHorasShareCare}
            empresa={empresa}
            
            createPayment={createPayment}
            get_clientSecret={get_clientSecret}
            clientSecret={clientSecret}  
            stripeMessage={stripeMessage}
            factura={factura}
        />


			{/********************************************************************************************************************** */}
			{/********************************************************************************************************************** */}
			{/********************************************************************************************************************** */}
			{/********************************************************************************************************************** */}
			{/********************************************************************************************************************** */}
			{/********************************************************************************************************************** */}

			<M
				centered={true}
				show={ModalUsuarioNoRegistrado}
			>
				<M.Header>
					<div className='titulo-modal'>
						Necesitas iniciar sesión para contratar un servicio
					</div>
				</M.Header>
				<M.Body>
					<div className='descripcion-servicio descripcion-modal'>
						Para proceder con la contratación de un servicio, es necesario que accedas a tu cuenta. Si ya eres usuario, introduce tus credenciales. En caso de no disponer de una cuenta, te invitamos a registrarte en nuestra plataforma. Una vez completado este paso, tendrás acceso completo a nuestra oferta de servicios.
					</div>
				</M.Body>
				<M.Footer>
					<div className='centrador-Botones-botones-perfil-empresa'>
						<div
							className='btn outline-boton w-25'
							onClick={() => {
								setModalUsuarioNoRegistrado(false);
							}}
						>
							<b>Aceptar</b>
						</div>
						<div
							className='btn login-boton w-25'
							onClick={() => {
								navigate('/login/perfilAgencia-' + idPrestador);
								setModalUsuarioNoRegistrado(false);
							}}
						>
							<b>Iniciar sesión</b>
						</div>
					</div>
				</M.Footer>
			</M>

			{/********************************************************************************************************************** */}
			{/********************************************************************************************************************** */}
			{/********************************************************************************************************************** */}
			{/********************************************************************************************************************** */}
			{/********************************************************************************************************************** */}
			{/********************************************************************************************************************** */}

			<M
				centered={true}
				show={ModalPacientes}
			>
				<M.Header>
					<div className='titulo-modal'>Agrega a la persona que recibirá el servicio.</div>
				</M.Header>
				<M.Body>
					<div className='descripcion-servicio descripcion-modal'>
						Para contratar un servicio, primero debes agregar a la persona que recibirá el servicio, el cual puede ser uno mismo. Proporciona sus datos básicos y podrás continuar con el proceso.
					</div>
				</M.Body>
				<M.Footer>
					<div className='centrador-Botones-botones-perfil-empresa'>
						<div
							className='btn outline-boton w-25'
							onClick={() => {
								setModalPacientes(false);
							}}
						>
							<b>Aceptar</b>
						</div>
						<div
							className='btn login-boton w-25'
							onClick={() => {
								navigate('/misPacientes/perfilAgencia-' + idPrestador);
								setModalPacientes(false);
							}}
						>
							<b>Ir a mis usuarios</b>
						</div>
					</div>
				</M.Footer>
			</M>
		</>
	);
};
